<template>
  <div class="main-container">
    <div class="bgposition">
        <div v-for="item in bgarr" class="bg_block" :style="{backgroundImage: 'url('+ item.img + ')',height:item.height+'px'}"></div>
    </div>
    <div class="position_relative">
        <div class="_2014_618_desc1">618大促琳琅满目的商品以及优惠活动想必让大家又患上选择困难症了，小鱼科学测评让你不买错，品质好物放心购！</div>
        <div v-for="(item,index) in productDatas">
            <img :src="item.titleImg"  class="_618_title1 margin_top_46" 
                :class="item.titleImgClass"></img>
                <div class="_618_block1_desc">{{item.desc}}</div>
                <div class="_618_block1_box" :class="val.margin_top" :style="{backgroundImage: 'url('+ val.imgbg + ')',height:val.height+'px'}" v-for="(val,valindex) in item.categorys">
                    <!-- <img :src="val.title"  class="_618_block_titleimg"></img> -->
                    <div class="_618_block_text " :class="val.paddingclass">{{val.desc}}</div>
                    <div class="box_padding">
                        <div v-for="(value,valueindex) in val.products" class="_618_product_box display_flex" @click="toProductDetail(value.type,value.id)" >
                            <div class="_618_product_box_img">
                                <img :src="value.img" 
                                class=" center" :class="value.imgclass"></img>
                                <img src="https://p1.fishqc.net/FooMAleWAOXTrBgw2AHWIIjiDZL4" class="greenfish"></img>
                            </div>
                            <div  class="product_detail_contain display_flex  derection-column justify-content_flex-justify" style="flex:1" :class="{'padding_right_1':value.id == 'm0y5kZo-ICWELyBMy-4TQQ'}">

                                <div class="product_name" v-html="value.productname"></div>
                                <div>
                                    <div class="product_tab">{{value.tips}}</div>
                                    <div class="brand" :class="{'padding_top_10':(value.id == 'm0y5kZo-ICWELyBMy-4TQQ'  || value.id == 'pENF2Fy8G-uql2Q_xux6rQ')}">品牌所在地：{{value.address}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                        
                    
                </div> 
        </div>
        <div v-for="value in technoarr">
            <img :src="value.img"  class="tech" :class="value.class"></img>

        </div>

    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
div {
  box-sizing: border-box;
}

.mb-0 {
  margin-bottom: 0!important;
}

.desc {
  width: 880px;
  margin-bottom: 20px;
  text-align: left;
  font-size: 24px;
  font-weight: 800;
  line-height: 36px;
}

.main-container {
  box-sizing: border-box;
  height: 7800px;
  padding-top: 588px;
  margin: 100px auto 0;
  position: relative;
/*  background: url('https://p1.fishqc.net/lqqJK1qpDxhGKNAFM3hH3g77UlFO') center center no-repeat;*/
/*  background-size: auto 100%;*/
  color: #1B5EAD;
}

.bgposition{
    position: absolute;
    left:0;
    top:0px;
    width:100%;
    height: 7800px;
}


.bg_block{
    width:100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: auto 100%;
}


.position_relative{
    position: relative;
}

._2014_618_desc1{
    width: 918px;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 32px;
    color: #FEFEFE;
    line-height: 48px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin:0 auto;
}

._618_title1{
    margin:0 auto;
    display: block;
    &.margin_top_46{
        margin-top:46px;
    }
    
    
    &.size1{
        width:378px;
        height:87px;
        margin-bottom: 22px;
    }
    
    &.size2{
        width:394px;
        height:87px;
        margin-top:84px;
        margin-bottom: 30px;
    }
}

._618_block1_desc{
    width: 892px;
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 32px;
    color: #FEFEFE;
    line-height: 56px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin:0 auto;
}


._618_block1_box{
    width:989px;
    height:844px;
/*    background:url('https://p1.fishqc.net/FsoQwAGkaQEA2v4VP2wUFBwax5Bf');*/
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    margin:0 auto;

    &.margin_top_70{
        margin-top:70px;
    }
    &.margin_top_104{
        margin-top:104px;
    }

    &.margin_top_86{
        margin-top:86px;
    }
    &.margin_top_88{
        margin-top:88px;
    }
}

._618_block_titleimg{
    width: 285px;
    height: 69px;
    margin-left: 8px;
}

._618_block_text{
    width: 884px;
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 25px;
    color: #191919;
    line-height: 50px;
    text-align: justify;
    font-style: normal;
    text-transform: none;
    margin:0 auto;
    &.padding_1{
        padding-top: 90px;
        padding-bottom:44px;

    }

    &.padding_2{
        padding-top: 78px;
        padding-bottom:34px;
        
    }

    &.padding_3{
        padding-top: 112px;
        padding-bottom:40px;
        
    }

    &.padding_4{
        padding-top: 108px;
        padding-bottom:38px;
        
    }

    &.padding_5{
        padding-top: 112px;
        padding-bottom:38px;
        
    }

}

.box_padding{
   padding:0 30px;
   box-sizing: border-box;
   display: flex;
    flex-wrap: wrap;
}


.tech{
    display: block;
    margin:0 auto;
}
.techno1{
    width: 445px;
    height: 87px;
    margin-top:72px;

}
.techno2{
    width:991px;
    height: 1237px;
    margin-top:42px;
    
}
.techno3{
    width: 487px;
    height: 114px;
    margin-top:102px;
    
}

._618_product_box{
    width: 458px;
    height: 254px;
    background: #FFFFFF;
    border-radius: 20px 20px 20px 20px;
    border: 2px solid #A07EFF;
    vertical-align: top;
    padding:14px 0 14px 10px;
/*    float: left;*/
    cursor: pointer;
    &:nth-of-type(1){
        margin-bottom: 32px;
    }
    &:nth-of-type(2){
        margin-bottom: 32px;
        margin-left:12px;
    }
    &:nth-of-type(4){
/*        margin-bottom: 30px;*/
        margin-left:12px;
    }

    ._618_product_box_img{
        width: 158px;
        height: 225px;
        background: url('https://p1.fishqc.net/FjE7rvELuC5UgxrrXYV79EDsQ71a') center center no-repeat;
        background-size: contain;
        position: relative;
        .center{
            position: absolute;
            top:50%;
            left:50%;
            transform: translate(-50%,-50%);
        }

        .greenfish{
            width:98px;
            height: 95px;
            position: absolute;
            left:-10px;
            bottom:0;
        }

        ._618_product1{
            width:46px;
            height:174px;
        }
        ._618_product2{
            width:60px;
            height:178px;
        }
        ._618_product3{
            width:57px;
            height:172px;
        }
        ._618_product4{
            width:58px;
            height:179px;
        }
        ._618_product5{
            width:49px;
            height:192px;
        }
        ._618_product6{
            width:63px;
            height:177px;
        }
        ._618_product7{
            width:118px;
            height:80px;
        }
        ._618_product8{
            width:77px;
            height:165px;
        }
        ._618_product9{
            width:117px;
            height:102px;
        }
        ._618_product10{
            width:101px;
            height:127px;
        }
        ._618_product11{
            width:113px;
            height:87px;
        }
        ._618_product12{
            width:110px;
            height:98px;
        }
        ._618_product13{
            width:131px;
            height:74px;
        }
        ._618_product14{
            width:132px;
            height:92px;
        }
        ._618_product15{
            width:89px;
            height:150px;
        }
        ._618_product16{
            width:104px;
            height:152px;
        }
        ._618_product17{
            width:78px;
            height:153px;
        }
        ._618_product18{
            width:103px;
            height:104px;
        }
        ._618_product19{
            width:81px;
            height:170px;
        }
        ._618_product20{
            width:53px;
            height:186px;
        }

    }
}


.flex_one{
    -webkit-box-flex: 1;
    -ms-flex: 1;
    -webkit-flex: 1;
    flex: 1;    
}

.product_detail_contain{
    padding-left: 16px;
}

.product_name{
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 22px;
    color: #191919;
    line-height: 33px;
    text-align: left;
    font-style: normal;
    text-transform: none;
}

.product_tab{
    width: 128px;
    height: 38px;
    background: linear-gradient(to left,  #9B41CE,#774BCD);
    box-shadow: inset 3px 0px 9px 0px #BBA7FF;
    border-radius: 16px 0px 16px 0px;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 22px;
    color: #FFFFFF;
    line-height: 38px;
    text-align: center;
}

.brand{
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 23px;
    color: #191919;
    line-height: 24px;
    text-align: left;
    padding-top:22px;
    padding-bottom:12px;
    &.padding_top_10{
        padding-top:10px;
    }
}
.derection-column{
    flex-direction: column;
    -webkit-flex-direction: column;
}
</style>
<script>
import { myMixin } from '@/mixin/mixin.js'
export default {
  // name: '2023-618',
  mixins: [myMixin],
  data() {
    return {
        bgarr:[
            {
                img:'https://p1.fishqc.net/Fm-w9H-GSUhMep0SZ2nyUDnjLZAJ',
                height:'534'
            },
            {
                img:'https://p1.fishqc.net/FhL08CGij3wZdxDNk-j9956fvbh4',
                height:'1002'
            },
            {
                img:'https://p1.fishqc.net/Fvy2iseTG0K33kabERaobyimLUkw',
                height:'1074'
            },
            {
                img:'https://p1.fishqc.net/Fh0XSbswrV3SltjM82fTE6K2WX94',
                height:'1392'
            },
            {
                img:'https://p1.fishqc.net/FnO31lRkYtFY9_d47bsWujA2XpJA',
                height:'1278'
            },
            {
                img:'https://p1.fishqc.net/Fvt9vFkHe4foqM7Pf6PdqNJ8YgfD',
                height:'1302'
            },
            {
                img:'https://p1.fishqc.net/Fn4uTh8B3yDoUYCAPdNc8M2dN3Ae',
                height:'1218'
            }
        ],
        productDatas: [
            {
                titleImg: 'https://p1.fishqc.net/FoGdXAsr8-75RsA5bW4YxsMpHXB2',
                desc:'大促必购好物少不了精致女孩的日常护肤优品，恰逢春夏换季，更要选择适合安全护肤品，跟着绿鱼榜单618不买错。',
                titleImgClass:'size1',
                categorys: [{
                        title: 'https://p1.fishqc.net/FqMsJrZXvnmi2Cuwu4rokQJed3Y9',
                        desc: '精华液能够由肌肤表面进入到肌肤的基底层，发挥作用。选择合适安全的精华极其重要。',
                        paddingclass:'padding_1',
                        margin_top:'margin_top_70',
                        imgbg:'https://p1.fishqc.net/FkDIqUx4PLmu4q11Fpt6lNTP-_f5',
                        height:'839',
                        products: [{
                                img: 'https://p1.fishqc.net/FgEkMFaezHmpNliDRSgetzszGOPf',
                                imgclass:'_618_product1',
                                productname:'PURID朴理<br>创研修护焕漾精华液<br> （2号精华）',
                                brand: 'PURID 朴理',
                                title: '创研修护焕漾精华液<br>(2号精华)',
                                tips: '抗红御氧',
                                address: '中国',
                                type: 'cosmetic',
                                id: 'uBKKOZ0Ao5UKRKyj9CEC6g',
                                
                            },
                            {
                                img: 'https://p1.fishqc.net/FhCfyfIfsLUn8G6ZJTIzvNVO46YH',
                                imgclass:'_618_product2',
                                productname:'COSME DECORTE黛珂<br>莹润粹白璇亮菁华液',
                                brand: 'GRASUS 瑰倚丝',
                                title: '果萃柔肤精华液',
                                tips: '焕亮嫩肤',
                                address: '日本',
                                type: 'cosmetic',
                                id: 'h5LBDZFWWgR7W287E052Wg',
                                
                            },
                            {
                                img: 'https://p1.fishqc.net/Fi0tsbEJyJjaX5JYoKsISChc6d4I',
                                imgclass:'_618_product3',
                                productname:'HELENA RUBINSTEIN<br>赫莲娜<br>绿宝瓶强韧修护精华露',
                                brand: 'HELENA RUBINSTEIN<br>赫莲娜',
                                title: '至盈抚纹精华液',
                                tips: '重塑屏障',
                                address: '法国',
                                type: 'cosmetic',
                                id: 'Dso7hCiX3Ui4DtL4ek3MLA',
                                
                            },
                            {
                                img: 'https://p1.fishqc.net/FjnwhmKoZFhKRlJGWhROK8j6R5ZF',
                                imgclass:'_618_product4',
                                productname:'GRASUS瑰倚丝<br>果萃柔肤精华液',
                                brand: "KIEHL'S科颜氏 ",
                                title: '集焕白均衡亮肤淡斑精华液',
                                tips: '软化角质',
                                address: '中国',
                                type: 'cosmetic',
                                id: 'g9RkjEhY_8FoisLx5_PO4Q',
                                
                            }
                        ]
                    },
                    {
                        title: 'https://p1.fishqc.net/FqnLzKy-29LaQDJWZyuYQ4pXgXCJ',
                        desc: '乳液滋润，更是皮肤的屏障，保护肌肤免受外部伤害。天气逐渐炎热，可根据肤质选择更水润的安全乳液。',
                        paddingclass:'padding_2',
                        margin_top:'margin_top_104',
                        imgbg:'https://p1.fishqc.net/FtkTpsXWOoyIOJzu0mTKhBE65I3D',
                        height:'840',
                        products: [
                            {
                                img: 'https://p1.fishqc.net/FrqkcNf1uuGws9NNU5U9ZcSx21IH',
                                imgclass:'_618_product5',
                                productname:'善草纪<br>茉莉滢润保湿精华乳',
                                brand: 'GÈNECHER简莳',
                                title: '臻妍眼部精华液',
                                tips: '嫩滑光泽',
                                address: '中国',
                                type: 'cosmetic',
                                id: 'unISAIvq50vJuofQsWi1ZA',
                                
                                
                            },
                            {
                                img: 'https://p1.fishqc.net/FiEkzXvEgN5y-VEvm2BZl5iYrQ_D',
                                imgclass:'_618_product6',
                                productname:'MUJI无印良品<br>基础润肤乳液 高保湿型',
                                brand: 'URIAGE依泉',
                                title: '多功能眼霜',
                                tips: '强效保湿',
                                address: '日本',
                                type: 'cosmetic',
                                id: 'igxZpnpfFnfefQrVXtU5Yw',
                                
                            },
                            {
                                img: 'https://p1.fishqc.net/FmVqK1wJEEd1QfcEnC3_pAmIKKTM',
                                imgclass:'_618_product7',
                                productname:'ORIGINS悦木之源<br>复活草水润修护凝乳',
                                brand: 'URIAGE依泉',
                                title: '多功能眼霜',
                                tips: '滋润补水',
                                address: '美国',
                                type: 'cosmetic',
                                id: 'iwcT8TZLCd_n7F2s2vIxGg',
                                
                            },
                            {
                                img: 'https://p1.fishqc.net/FstxImRGpB3pvHqncbuAEHMxTYmv',
                                imgclass:'_618_product8',
                                productname:'EAU THERMALE AVENE<br>雅漾<br>高效抗敏舒缓保湿乳',
                                brand: 'URIAGE依泉',
                                title: '多功能眼霜',
                                tips: '舒缓维稳',
                                address: '法国',
                                type: 'cosmetic',
                                id: 'vawwnwDwvEzAbIO1K5uG-g',
                                
                            }
                        ]
                    },
                    {
                        title: 'https://p1.fishqc.net/FvL_9dC4BVY401ELeauzvkd_ir-j',
                        desc: '面霜能有效的锁住我们肌肤内部的水分和营养，同时也能给肌肤补充水分和养分，干性皮肤在夏季也很需要。',
                        paddingclass:'padding_3',
                        margin_top:'margin_top_86',
                        imgbg:'https://p1.fishqc.net/FrHKbHY5vQVd4RNpAE7C5nESVuN-',
                        height:'844',
                        products: [{
                                img: 'https://p1.fishqc.net/FhPe3OmuoSsvpQy48VaodfReSHZS',
                                imgclass:'_618_product9',
                                productname:'LOREAL欧莱雅<br>复颜玻尿酸水光充盈<br>焕颜淡纹霜',
                                brand: 'MyClorisLand花皙蔻',
                                title: '菁纯牡丹抗皱淡纹精华霜',
                                titleFont: true,
                                tips: '新生愈肤',
                                address: '法国',
                                type: 'cosmetic',
                                id: 'oRktomZzX-AyGcmbpCPXKw',
                                bgSize: 'contain',
                                
                            },
                            {
                                img: 'https://p1.fishqc.net/Fp8KrgOWw3a5COTEap2-0QIQAZIb',
                                imgclass:'_618_product10',
                                productname:'MyClorisLand花皙蔻<br>菁纯牡丹抗皱淡纹精华霜',
                                brand: 'SKINCEUTICALS<br>修丽可',
                                title: '紧致塑颜面霜',
                                tips: '紧致淡纹',
                                address: '中国',
                                type: 'cosmetic',
                                id: 'li4ioIgu8L4wYXMSzN4LYA',
                                
                            },
                            {
                                img: 'https://p1.fishqc.net/FnZde08-eWgYTiT-rVZTLWLExFr0',
                                imgclass:'_618_product11',
                                productname:'CUREL珂润<br>润浸保湿滋养乳霜',
                                brand: 'SKINCEUTICALS<br>修丽可',
                                title: '紧致塑颜面霜',
                                tips: '深层补水',
                                address: '日本',
                                type: 'cosmetic',
                                id: 'F0jP8U9azuisaJBtivYieA',
                                
                            },
                            {
                                img: 'https://p1.fishqc.net/FrNZLY9LGU9QURXaw9w6xFoqYOHK',
                                imgclass:'_618_product12',
                                productname:'SKINCEUTICALS修丽可<br>紧致塑颜面霜',
                                brand: 'SKINCEUTICALS修丽可<br>紧致塑颜面霜',
                                title: '紧致塑颜面霜',
                                tips: '卓效抗老',
                                address: '美国',
                                type: 'cosmetic',
                                id: 'HcLChmVn61Jxp9fVCxFG2w',
                                
                            }
                        ]
                    }
                    
                ]
            },
            {
                titleImg: 'https://p1.fishqc.net/FsMR-koX9fIUaJq2_-zJRFCylmJQ',
                desc:'生活个人护理用品可谓大促必囤，使用频率高消耗快，更要注重安全，榜单好物通过科学测评，618放心购。',
                titleImgClass:'size2',
                categorys: [{
                        title: 'https://p1.fishqc.net/Fh544nkH1uejEMEvLXgzAHenCXlK',
                        desc: '618大促囤纸品必不可少，面巾纸、卫生纸、湿巾纸、厨房纸等等，劣质纸品影响极大，跟着绿鱼榜单选，全家安心。',
                        paddingclass:'padding_4',
                        margin_top:'margin_top_88',
                        imgbg:'https://p1.fishqc.net/FvmJiomfmiC9twGHYHana-HftOuL',
                        height:'845',
                        products: [{
                                img: 'https://p1.fishqc.net/Fic_zyQSUknjVjHpT5YW-UwOdRRy',
                                imgclass:'_618_product13',
                                productname:'优可舒® <br>湿厕纸（Pro款）',
                                brand: 'PURID 朴理',
                                title: '创研修护焕漾精华液<br>(2号精华)',
                                tips: '加大加厚',
                                address: '中国',
                                type: 'cosmetic',
                                id: 'v_v2puERvw_PGEebz13vLw',
                                
                            },
                            {
                                img: 'https://p1.fishqc.net/Fp6TIF43aoE6924vXs5hx_Sb50-b',
                                imgclass:'_618_product14',
                                productname:'MANNINGS万宁<br>抗菌湿巾 茶树',
                                brand: 'GRASUS 瑰倚丝',
                                title: '果萃柔肤精华液',
                                tips: '杀菌清洁',
                                address: '中国香港',
                                type: 'cosmetic',
                                id: 'D0IxkbJJRQTqK-IXilEsMw',
                                
                            },
                            {
                                img: 'https://p1.fishqc.net/FvzMYYClc4gnGqh-U_2YPaNsM4Zv',
                                imgclass:'_618_product15',
                                productname:'ANDREX皇冠<br>湿厕纸',
                                brand: 'HELENA RUBINSTEIN<br>赫莲娜',
                                title: '至盈抚纹精华液',
                                tips: '去污除臭',
                                address: '英国',
                                type: 'cosmetic',
                                id: '8cuFidDYF3Bcr104CFW1DA',
                                
                            },
                            {
                                img: 'https://p1.fishqc.net/FvBaehXwI5fAIgD9M6kjcdN8YQbZ',
                                imgclass:'_618_product16',
                                productname:'TEMPO得宝<br>抗菌倍护湿纸巾',
                                brand: "KIEHL'S科颜氏 ",
                                title: '集焕白均衡亮肤淡斑精华液',
                                tips: '一抹净爽',
                                address: '德国',
                                type: 'cosmetic',
                                id: '_MTNbaGEsqOCA9iRKA5qDA',
                                
                            }
                        ]
                    },
                    {
                        title: 'https://p1.fishqc.net/FsEVRtQ0bYEUxNgNX9DrAsto75kp',
                        desc: '夏季来临，日晒与紫外线，不仅会引起皮肤损伤，黑色素沉着，更重要是使皮肤老化，看准好物榜单不踩雷。',
                        paddingclass:'padding_5',
                        margin_top:'margin_top_88',
                        imgbg:'https://p1.fishqc.net/FgCYMyPQ4RBBx-9caFp-qE7FdOEE',
                        height:'842',
                        products: [
                            {
                                img: 'https://p1.fishqc.net/FqEshhMvlJfyeeq7QryxSLYGXhlZ',
                                imgclass:'_618_product17',
                                productname:'ANESSA安热沙<br>金钻防晒露<br>SPF50+ PA++++',
                                brand: 'GÈNECHER简莳',
                                title: '臻妍眼部精华液',
                                tips: '经典之王',
                                address: '日本',
                                type: 'cosmetic',
                                id: 'cB2FgmQEHHzA32fRRt1_Tw',
                                
                                
                            },
                            {
                                img: 'https://p1.fishqc.net/FuWHPgIKfpq0oyOeYGAFSduz5k2Y',
                                imgclass:'_618_product18',
                                productname:'FOTOPROTECTOR ISDIN<br>怡思丁<br>多维光护沁融水感防晒液<br>SPF50+',
                                brand: 'URIAGE依泉',
                                title: '多功能眼霜',
                                tips: '水感清透',
                                address: '西班牙',
                                type: 'cosmetic',
                                id: 'pENF2Fy8G-uql2Q_xux6rQ',
                                
                            },
                            {
                                img: 'https://p1.fishqc.net/FqMlFHUG9MKft9-qAi0-vscrluMh',
                                imgclass:'_618_product19',
                                productname:'NIVEA妮维雅<br>水感防日光保湿啫喱<br>SPF50 PA+++',
                                brand: 'URIAGE依泉',
                                title: '多功能眼霜',
                                tips: '平价大碗',
                                address: '德国',
                                type: 'cosmetic',
                                id: 'H1RwxIoptj0LO0Tiasdtbg',
                                
                            },
                            {
                                img: 'https://p1.fishqc.net/FkOSfzpgUGt7KX3wQ-_VEQu5nu39',
                                imgclass:'_618_product20',
                                productname:"L'OREAL PARIS<br>巴黎欧莱雅<br>多重防护城市水活隔离噴雾<br>SPF42 PA++++",
                                brand: 'URIAGE依泉',
                                title: '多功能眼霜',
                                tips: '一喷成膜',
                                address: '法国',
                                type: 'cosmetic',
                                id: 'm0y5kZo-ICWELyBMy-4TQQ',
                                
                            }
                        ]
                    }
                    
                    
                ]
            },
            
        ],
        technoarr:[
            {
                img:'https://p1.fishqc.net/FlFqMnFHNOm1_hExkW6ELts1BLXw',
                class:'techno1'
            },
            {
                img:'https://p1.fishqc.net/FlldG81wDGxsKekQXwK-Vr8zl-Iy',
                class:'techno2'
            },
            {
                img:'https://p1.fishqc.net/FiHl3F7Yplem1D0xVDUJKZjVwTwx',
                class:'techno3'
            }
        ]
                
    }

  },
  computed: {
    swiper() {
      return this.$refs.order_report_Swiper.$swiper
    }
  },
  mounted() {
    // var position  =  this.$route.query.position
    // this.scrollTo(position)
    this.currentlang = window.localStorage.getItem("LOCALE") || 'chs'
  },
  methods: {
    scrollTo(position) {
      var that = this;
      var scroll_H;
      this.$nextTick(function () {
        if (position == 'greenrank') {
          var d = document.getElementById("greenrank");
          var topPos = d.offsetTop;
          scroll_H = topPos - 110; //减去header高度
        } else {
          scroll_H = this.$refs[position].offsetTop - 110; //减去header高度
        }
        //全局方法
        that.scrollToY(scroll_H, 1500, 'easeInOutQuint');
      })
    },
    toProductDetail(type, prdid) {
      this.$router.push({
        path: '/product/' + type + '/' + prdid
      })

    }
  }
}
</script>